<div class="or-p-32-px">
  <div class="or-d-flex or-justify-content-center">
    <span class="or-head-xl or-mb-16-px or-text-align-center">Potwierdzenie zmiany</span>
  </div>
  <div class="or-d-flex or-justify-content-center or-text-align-center or-mb-20-px">
    <span class="or-text-md">
      Czy na pewno chcesz {{ newValue ? 'włączyć' : 'wyłączyć' }} flagę "{{ flagName }}"? Jeśli chcesz kontynuować,
      wpisz "tak".
    </span>
  </div>

  <div
    class="or-mb-24-px"
    style="border: 2px solid #5a31f4; border-radius: 8px; padding: 8px; background-color: #f5f5f5">
    <ion-input
      type="text"
      placeholder="Wpisz 'tak' aby potwierdzić"
      [(ngModel)]="inputValue"
      class="or-text-md"></ion-input>
  </div>

  <div class="or-d-flex">
    <button class="button-secondary-style or-h-48-px or-w-60-pc or-head-sm or-mr-8-px" (click)="closeModal()">
      Anuluj
    </button>
    <button class="button-primary-style or-h-48-px or-w-60-pc or-head-sm" (click)="handle()">Potwierdź</button>
  </div>
</div>
